import SEO from "components/seo"

export default function ContentPageContainer({
  title,
  image,
  description,
  children,
}) {
  return (
    <>
      <SEO title={title} image={image} description={description} />
      <main className="relative py-24 lg:pt-36">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="whitespace-pre-line text-4xl font-extrabold tracking-tight text-zinc-800 sm:text-5xl lg:text-6xl">
              {title}
            </h1>
            <div className="divide-y">{children}</div>
          </div>
        </div>
      </main>
    </>
  )
}
